import { Link } from "@/components/common/Link";
import { Instagram, Linkedin, Twitter } from "lucide-react";
export default function FooterInformation() {
  const evolveLinks = [{
    label: "Products",
    href: "#"
  }, {
    label: "Services",
    href: "#"
  }, {
    label: "Our Story",
    href: "#"
  }, {
    label: "Schedule",
    href: "#"
  }];
  const helpLinks = [{
    label: "FAQ",
    href: "#"
  }, {
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Terms of Use",
    href: "#"
  }, {
    label: "Support",
    href: "#"
  }];
  return <section data-section-id="37354" id="footer" className="dark bg-primary border-t border-primary-foreground/10 py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524006/img/metafinish_logo.png" alt="BrandPulse" className="h-7 w-auto object-contain" />
            </Link>
            <div className="flex flex-col gap-2 text-sm text-primary-foreground/70 font-sans">
              <p>123 Lowcountry Blvd, Charleston</p>
              <p>(843) 555-0123</p>
              <p>hello@brandpulse.com</p>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg tracking-wider text-primary-foreground">Explore</h3>
            <ul className="flex flex-col gap-3">
              {evolveLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors font-sans">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg tracking-wider text-primary-foreground">Legal</h3>
            <ul className="flex flex-col gap-3">
              {helpLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors font-sans">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg tracking-wider text-primary-foreground">Connect</h3>
            <div className="flex items-center gap-4">
              <Link to="#" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors border border-primary-foreground/30 rounded-full" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="#" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors border border-primary-foreground/30 rounded-full" aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
              <Link to="#" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors border border-primary-foreground/30 rounded-full" aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}